import React from "react";
import SubPageTemplate from "../../components/subpagetemplate";
import { useCategoryOffers } from "../../hooks/useCategoryOffers";
import HelmetSeo from "../../components/HelmetSeo";
import { pageSeoConfig } from "../../config/pageSeo";

const Gifts: React.FC = () => {
  const giftsData = useCategoryOffers("gifts");
  const seoMeta = pageSeoConfig.gifts;

  return (
    <>
      <HelmetSeo title={seoMeta.title} description={seoMeta.description} />
      <SubPageTemplate standard_categories={giftsData} title="Gifts" />
    </>
  );
};

export default Gifts;
